var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"cursor-help",attrs:{"right":"","color":"warning"}},'v-icon',attrs,false),on),[_vm._v("warning")])]}}])},[_c('span',[_vm._v("Integração com o VSTS bloqueada")])])}
var staticRenderFns = []

export { render, staticRenderFns }